import React, { FC } from 'react';
import { SectionWrapper } from '../SectionWrapper';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { APPLICATION_VIEW_FEES } from '../../constants/application-view/application-view-fees';
import { FakeInput } from '../form/FakeInput';

export const ApplicationViewFees: FC = () => {
  const { t } = useTranslation();
  const { merchantState: { applicationViewFees }} = useMerchants();

  const INPUTS = APPLICATION_VIEW_FEES({ fees: applicationViewFees });
  return (
    <SectionWrapper
      title={t('SELF_ONBOARDING.SECTION_TITLE.PRICING')}
      pageLoading={false}
      isCardBody
      sectionAdditionalClass="mb-10"
    >
      <div className="d-flex align-items-center flex-wrap">
        {
          INPUTS.map(item => (
            <FakeInput
              {...item}
              key={item.key}
            />
          ))
        }
      </div>

    </SectionWrapper>
  );
};
